import React, { useEffect, useMemo, useState, useRef } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import CustomPagination from "../CustomWidgets/CustomPagination";
import { Empty, Input, InputNumber, Modal } from "antd";
import Edit from "../../assets/Edit.svg";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import ProductModal from "../../modals/showproductmodal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import dummy_image from "../../assets/Images/gallery.svg";
import { useNavigate } from "react-router-dom";
import { checkPermission } from "../../Utils/permissionHelper";
import { useSelector } from "react-redux";
import JsBarcode from "jsbarcode";
import labelSample from "../../assets/35mm.png";

const InventoryTableComponent = ({
  additionalData,
  setAdditionalData,
  callafterUpdate,
  pagination,
}) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const [editRows, setEditRows] = useState(new Set());
  const [editValues, setEditValues] = useState({});
  const [editPriceClicked, setEditPriceClicked] = useState(false);
  const [indexarray, setindexarray] = useState([]);
  const [showpopup, setshowpopup] = useState(false);
  const [showpopupdata, setshowpopupdata] = useState([]);
  const costPriceInputRefs = useRef({});
  const sellPriceInputRefs = useRef({});
  const qtyInputRefs = useRef({});
  const timeoutRef = useRef(null);
  const focusedInputRef = useRef(null);
  const [tempEditValues, setTempEditValues] = useState({});
  const [isSalePriceValid, setIsSalePriceValid] = useState({});
  const [isImageModalVisible, setIsImageModalVisible] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState("");
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );
  const userData = useSelector((state) => state?.login?.user?.result);
const [showPriceModal, setShowPriceModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);



  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );

  const data = useMemo(
    () =>
      additionalData?.status
        ? additionalData?.all_product
        : additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  useEffect(() => {
    handleEditCancel();
  }, [additionalData]);

  const BarcodeCell = ({ row }) => {
    const navigate = useNavigate();
    const productId = row?.original?.quant_id;

    // console.log("row.original", row.original);

    return (
      <div
        className="flex justify-start text-start cursor-pointer"
        onClick={() => navigate(`/productdetails?Id=${productId}`)}
      // /Orderlist?orderDetail=${orderNumber}
      >
        <span>{row.original.barcode}</span>
      </div>
    );
  };


  const toggleSelectProduct = (item) => {
    setSelectedProducts(prev => {
      const exists = prev.find(p => p.id === item.quant_id);

      if (exists) {
        // remove
        return prev.filter(p => p.id !== item.quant_id);
      }

      // add
      return [
        ...prev,
        {
          id: item.quant_id,
          name: item.product_name || item.name,
          barcode: item.barcode,
          price: item.current_price || item.sale_price
        }
      ];
    });
  };

  const columns = useMemo(
    () => [

      {
        id: "selection",
        Header: () => (
          <input
            type="checkbox"
            checked={page.every(row => selectedProducts.some(p => p.id === row.original.quant_id))}
            onChange={e => {
              const checked = e.target.checked;

              page.forEach(row => {
                toggleSelectProduct(row.original, checked);
              });
            }}
          />
        ),
        Cell: ({ row }) => (
          <input
            type="checkbox"
            checked={selectedProducts.some(p => p.id === row.original.quant_id)}
            onChange={() => toggleSelectProduct(row.original)}
          />
        ),
        width: 30
      },


      {
        Header: t(""),
        accessor: "product_image_url",
        headerClassName: "text-center",
        width: 40, // Fixed width for the image column
        Cell: ({ row }) => (
          <div className="flex h-50 items-center justify-center">
            {" "}
            {/* Center alignment */}
            {/* {row.original.product_image_url || row.original.image ? ( */}
              <img
                src={dummy_image}
                alt="Dummy"
                style={{
                  maxHeight: 30,
                  maxWidth: 30,
                  minHeight: 30,
                  minWidth: 30,
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentImageUrl(
                    row.original.product_image_url || row.original.image
                  );
                  setIsImageModalVisible(true);
                }}
              />
            {/* ) : (
              <img
                style={{
                  maxHeight: 40,
                  maxWidth: 40,
                  minHeight: 40,
                  minWidth: 40,
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                src={row.original.product_image_url || row.original.image}
                height={60}
                width={30}
                alt="prod_image"
              />
            )} */}
          </div>
        ),
      },
      {
        Header: ({ column }) => (
          <div className="text-start" title={t("Barcode")}>
            {t("Barcode")}
          </div>
        ),
        accessor: "barcode",
        headerClassName: "text-start",
        width: 80,
        Cell: BarcodeCell,
      },
      {
        Header: (
          <div className="text-center text-balance" title={t("Product Name")}>
            {t("Product Name")}
          </div>
        ),
        // t("Product Name"),
        accessor: "product_name",
        headerClassName: "text-start",
        width: 250, // Fixed width for the product name column
        Cell: ({ row }) => (
          <div className="flex justify-center ms-10">
            {" "}
            {/* Center alignment */}
            <span>{row.original.product_name}</span>
          </div>
        ),
      },

      {
        Header: (
          <div className="text-center text-balance" title={t("Custom Product Name")}>
            {t("Custom Product Name")}
          </div>
        ),
        accessor: "product_name2",
        headerClassName: "text-start",
        width: 130,
        Cell: ({ row }) => {
          const customName =
            editRows[row.index]?.product_name2 ?? // live edited value
            row.values.product_name2 ?? "";       // original value

          return editRows.has(row.index) && !userData?.is_sub_store ? (
            <div className="flex justify-center w-full">
              <Input
                className="w-full"
                placeholder={customName}
                // value={customName == false ? '' : customName}
                onChange={(e) =>{
                  handleInputChange(row.index, "product_name2", e.target.value)
                }}
                // placeholder="Enter name"
                maxLength={150}
                 onFocus={() =>
                      handleInputFocus(row.index, "product_name2")
                    }
                     readOnly={userData?.is_sub_store}
              />
            </div>
          ) : (
            <div className="flex justify-center">
              <span>{customName}</span>
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-center text-balance w-9/12" title={t("Custom Product Name")}>
            {t("Product Shortcut")}
          </div>
        ),
        accessor: "product_shortcut",
        headerClassName: " text-center",
        width: 120,
        Cell: ({ row }) => {
          const customName =
            editRows[row.index]?.product_shortcut ?? // live edited value
            row.values.product_shortcut ?? "";       // original value

          return editRows.has(row.index) && !userData?.is_sub_store ? (
            <div className="flex justify-center w-full">
              <Input
                className="w-full"
                placeholder={customName}
                // value={customName == false ? '' : customName}
                onChange={(e) =>{
                  handleInputChange(row.index, "product_shortcut", e.target.value)
                }}
                // placeholder="Enter name"
                maxLength={150}
                 onFocus={() =>
                      handleInputFocus(row.index, "product_shortcut")
                    }
                     readOnly={userData?.is_sub_store}
              />
            </div>
          ) : (
            <div className="flex justify-center text-center">
              <span>{customName}</span>
            </div>
          );
        },
      },

      {
        Header: (
          <div
            className="text-start text-balance"
            title={t("Weighing Scale Product Code")}
          >
            {t("Weighing Scale Product Code")}
          </div>
        ),
        // t("Product Code"),
        accessor: "machine_barcode",
        headerClassName: "text-center",
        width: 100, // Fixed width for the product code column
        Cell: ({ row }) => {
          const machineBarcode =
            editValues[row.index]?.machine_barcode ??
            row.values.machine_barcode;
          const uom = row.original.uom;
         
          

          if (editRows?.has(row.index) && (uom === "KG" || uom === "كجم")) {
            return (
              <div className="flex justify-center">
                {" "}
                {/* Center alignment */}
                <InputNumber
                  className="w-20"
                  controls={false}
                  value={machineBarcode === false ? "" : machineBarcode}
                  onChange={(value) => {
                    if (value === "" || (value >= 0 && value <= 9999999)) {
                      handleInputChange(row.index, "machine_barcode", value);
                    }
                  }}
                  maxLength={7}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onFocus={(e) => e.target.select()}
                />
              </div>
            );
          }
          return (
            <div className="flex justify-center">
              {" "}
              {/* Center alignment */}
              {machineBarcode === false ? "" : `${machineBarcode}`}
            </div>
          );
        },
      },
      {
        Header: (
          <div className="text-center" title={t("category")}>
            {t("category")}
          </div>
        ),
        // t("category"),
        accessor: "categ_name",
        headerClassName: "text-center",
        width: 100, // Fixed width for the category column
        Cell: ({ row }) => (
          <div className="flex justify-center">
            {" "}
            {/* Center alignment */}
            <span>{row.original.categ_name}</span>
          </div>
        ),
      },
      {
        Header: (
          <div
            className="text-center w-9/12 text-balance"
            title={t("Sub Category")}
            style={{ maxWidth: "100px" }}
          >
            {t("Sub Category")}
          </div>
        ),
        //  t("Sub Category"),
        accessor: "sub_categ_name",
        headerClassName: "text-center",
        width: 90, // Fixed width for the sub-category column
        Cell: ({ row }) => (
          <div className="flex justify-start">
            {" "}
            {/* Left alignment */}
            <span>{row.original.sub_categ_name}</span>
          </div>
        ),
      },

      ...(!allStores
        ? [
          {
            Header: (
              <div
                className="text-center text-balance"
                title={t("Cost Price")}
                style={{ maxWidth: "100px" }}
              >
                {t("Cost Price")}
              </div>
            ),
            // Header: t("cost_price"),
            accessor: "current_cost_price",
            headerClassName: "text-center ms-2",
            width: 80, // Fixed width for the cost price column
            Cell: ({ row }) => (
              <div className="flex justify-center">
                {" "}
                {/* Right alignment */}
                {editRows?.has(row.index) ? (
                  <Input
                    type="number"
                    className="w-16"
                    placeholder={row.values.current_cost_price}
                    ref={(element) =>
                      (costPriceInputRefs.current[row.index] = element)
                    }
                    value={tempEditValues[row.index]?.current_cost_price}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (
                        value === "" ||
                        (/^[0-9]*\.?[0-9]{0,2}$/.test(value) && value.length <= 5)
                      ) {
                        handleInputChange(row.index, "current_cost_price", value);
                      }
                    }}
                    maxLength={5}
                    onFocus={() =>
                      handleInputFocus(row.index, "current_cost_price")
                    }
                    onKeyPress={(e) => {
                      const value = e.target.value;
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key === "." &&
                        value.includes(".")
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                ) : (
                  `EGP ${(
                    editValues[row.index]?.current_cost_price ??
                    row.values.current_cost_price
                  )?.toFixed(2)}`
                )}
              </div>
            ),
          },
        ]
        : []),

      ...(!allStores
        ? [
          {
            Header: (
              <div
                className="text-center text-balance"
                title={t("sale_price")}
                style={{ maxWidth: "100px" }}
              >
                {t("Sale Price")}
              </div>
            ),
            // Header: t("sale_price"),
            accessor: "current_price",
            width: 80, // Fixed width for the sale price column
            Cell: ({ row }) => (
              <div className="flex justify-center">
                {" "}
                {/* Right alignment */}
                {editRows?.has(row.index) ? (
                  <Input
                    type="number"
                    className={`w-16 ${isSalePriceValid[row.index] === false ? "border-red" : ""
                      }`}
                    placeholder={row.values.current_price}
                    ref={sellPriceInputRefs.current[row.index]}
                    value={tempEditValues[row.index]?.current_price}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (
                        value === "" ||
                        (/^\d*\.?\d{0,2}$/.test(value) && value.length <= 5)
                      ) {
                        handleInputChange(row.index, "current_price", value);
                      }
                    }}
                    maxLength={5}
                    onFocus={() => handleInputFocus(row.index, "current_price")}
                    onKeyPress={(e) => {
                      const value = e.target.value;
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key === "." &&
                        (value === "" || value.includes("."))
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                ) : (
                  `EGP ${(
                    editValues[row.index]?.current_price ?? row.values.current_price
                  )?.toFixed(2)}`
                )}
              </div>
            ),
          },
        ]
        : []),

      {
        Header: (
          <div
            className="text-center "
            title={t("Quantity")}
            style={{ maxWidth: "100px" }}
          >
            {t("Quantity")}
          </div>
        ),
        // Header: t("Quantity"),
        accessor: "system_quantity",
        width: 80, // Fixed width for the quantity column
        Cell: ({ row }) => {
          const uom = row.original.uom;
          return (
            <div className="flex justify-center">
              {" "}
              {/* Right alignment */}
              {editRows?.has(row.index) ? (
                <Input
                  type="text"
                  className="w-16"
                  placeholder={row.values.system_quantity}
                  ref={(element) => {
                    qtyInputRefs.current[row.index] = element;
                    focusedInputRef.current = element;
                  }}
                  min={0}
                  value={tempEditValues[row.index]?.system_quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (uom !== "Units" &&
                        /^\d*\.?\d{0,3}$/.test(value) &&
                        value.length <= 5) ||
                      (uom === "Units" &&
                        /^[0-9]*$/.test(value) &&
                        value.length <= 5)
                    ) {
                      handleInputChange(row.index, "system_quantity", value);
                    }
                  }}
                  onFocus={() => handleInputFocus(row.index, "system_quantity")}
                  onKeyPress={(e) => {
                    const value = e.target.value;
                    if (
                      (uom !== "Units" &&
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        !(
                          e.key === "." &&
                          (value === "" || !value.includes("."))
                        )) ||
                      (uom === "Units" &&
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace")
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              ) : (
                `${editValues[row.index]?.system_quantity ??
                row.values.system_quantity?.toFixed(2)
                }`
              )}
            </div>
          );
        },
      },
 
      ...(!allStores
        ? [
          {
            Header: "",
            accessor: "dropdown",
            width: 40, // Fixed width for the dropdown column
            Cell: (row) => (
              <div className="flex justify-center">
                {" "}
                {/* Center alignment */}
                <img
                  src={Edit}
                  style={{
                    cursor: "pointer",
                    height: "0.9rem",
                    width: "0.9rem",
                  }}
                  alt="Edit"
                  className={`mt--2 ${i18n.language == "en" ? "mr-2" : "ml-2"}`}
                  onClick={(e, index) => {
                    e.preventDefault();
                    setindexarray([...indexarray, parseInt(row.row.id)]);
                    handleEditRow(row.row.id);
                  }}
                />
              </div>
            ),
          },
        ]
        : []),
    ],
    [editRows, editValues, selectedProducts]
  );

  const inputRefs = useRef([]);

  const handleInputChange = (index, field, value) => {

    const textFields = ["product_name2"]; // add more text-based fields if needed
    const textFields2 = ["product_shortcut"]; // add more text-based fields if needed
    console.log("field", field);
    console.log("value", value);
    console.log("vaindexlue", index);




    if (textFields.includes(field)) {
      setTempEditValues((prevValues) => ({
        ...prevValues,
        [index]: {
          ...prevValues[index],
          [field]: value, // <-- store raw string
        },
      }));
      return;
    }
    
if (textFields2.includes(field)) {
      setTempEditValues((prevValues) => ({
        ...prevValues,
        [index]: {
          ...prevValues[index],
          [field]: value, // <-- store raw string
        },
      }));
      return;
    }
    // console.log("VALueeL", value);

    const numericValue = value === "" || value === null ? 0 : parseFloat(value); // Convert to number if valid

    setTempEditValues((prevValues) => ({
      ...prevValues,
      [index]: {
        ...prevValues[index],
        [field]: numericValue, // Update the field with the new value
      },
    }));

    if (field === "current_price") {
      const costPrice =
        tempEditValues[index]?.current_cost_price ??
        data[index].current_cost_price;
      if (numericValue < costPrice) {
        setIsSalePriceValid((prev) => ({ ...prev, [index]: false })); // Mark as invalid
      } else {
        setIsSalePriceValid((prev) => ({ ...prev, [index]: true })); // Mark as valid
      }
    }

    if (field === "discounted_price") {
      const salePrice =
        tempEditValues[index]?.current_price ?? data[index].current_price;
      if (numericValue > salePrice) {
        setIsSalePriceValid((prev) => ({ ...prev, [index]: false })); // Mark as invalid
      } else {
        setIsSalePriceValid((prev) => ({ ...prev, [index]: true })); // Mark as valid
      }
    }
  };

  const handleInputFocus = (index, field) => {
    if (inputRefs.current[index] && inputRefs.current[index][field]) {
      inputRefs.current[index][field].focus();
    }
  };


  const handleSaveAll = () => {
    // Iterate over all the rows in the edit mode
    for (const index of editRows) {
      // Get the sale price, cost price, and discounted price from the edited values
      const salePrice =
        tempEditValues[index]?.current_price !== undefined
          ? tempEditValues[index]?.current_price
          : data[index].current_price;

      const costPrice =
        tempEditValues[index]?.current_cost_price !== undefined
          ? tempEditValues[index]?.current_cost_price
          : data[index].current_cost_price;

      const discountedPrice =
        data[index].discounted_price > tempEditValues[index]?.current_price
          ? tempEditValues[index]?.current_price ?? data[index]?.current_price
          : tempEditValues[index]?.discounted_price ?? data[index]?.discounted_price;

      // Validate if the sale price is lower than cost price
      if (salePrice < costPrice) {
        toast.error(t("Sale price cannot be less than cost price."));
        return;
      }

      // Validate if the discounted price is higher than the sale price
      if (discountedPrice > salePrice) {
        toast.error(t("Discounted price cannot be greater than sale price."));
        return;
      }

      // Validate if the machine barcode is at least 7 digits long
      const rawBarcode = tempEditValues[index]?.machine_barcode ?? data[index]?.machine_barcode ?? "";
      const machineBarcode = rawBarcode.toString().trim();

      if (machineBarcode !== "0" && machineBarcode !== "false" && machineBarcode.length < 7) {
        toast.error(t("Product Code must be at least 7 digits"));
        return;
      }

      // Prepare the custom name value from the edited values or the existing data
      const customName =
        tempEditValues[index]?.product_name2 ?? data[index].product_name2;

    const prodShortcut =
        tempEditValues[index]?.product_shortcut ?? data[index].product_shortcut;
      // Now prepare the data to send in the payload
      let sendData = [];

      const newData = data?.map((row, idx) => { // <-- Ensure 'row' and 'idx' are used correctly
        if (editRows.has(idx)) {
          // Construct the object for the updated product with all the edited values
          const item = {
            quant_id: row?.quant_id ?? "", // Unique identifier for the product
            new_price:
              tempEditValues[idx]?.current_price ?? row?.current_price ?? 0,
            new_cost_price:
              tempEditValues[idx]?.current_cost_price ??
              row?.current_cost_price ??
              0,
            new_quantity:
              tempEditValues[idx]?.system_quantity ?? row?.system_quantity ?? 0,
            machine_barcode:
              tempEditValues[idx]?.machine_barcode !== undefined
                ? tempEditValues[idx].machine_barcode === 0
                  ? ""
                  : tempEditValues[idx].machine_barcode
                : row?.machine_barcode === 0
                  ? ""
                  : row?.machine_barcode ?? "",
            custom_name: customName, // Add the custom name to the payload
            product_shortcut:prodShortcut,
            discounted_price:
              data[idx].discounted_price >
                (tempEditValues[idx]?.current_price ?? row?.current_price ?? 0)
                ? (tempEditValues[idx]?.current_price ??
                  row?.current_price ??
                  0)
                : (tempEditValues[idx]?.discounted_price ??
                  row?.discounted_price ??
                  0),
          };

          // Push the updated product data into the sendData array
          sendData.push(item);

          // Return the updated row data
          return {
            ...row,
            ...tempEditValues[idx],
          };
        }
        // If the row is not being edited, return it unchanged
        return row;
      });

      // After all updates, clear the edit states and update the data
      setEditRows(new Set()); // Reset edit rows
      setindexarray([]); // Clear the index array
      setEditValues(tempEditValues); // Set the final edit values
      setTempEditValues({}); // Clear temporary edit values
      setEditPriceClicked(false); // Reset the flag for edit mode
      setAdditionalData(sendData); // Update the data with the new changes
    }
  };



  const handleEditRow = (index) => {
    if (checkPermission("/inventory", isGinne)) {
      setEditRows(new Set([...indexarray, parseInt(index)]));
      setEditPriceClicked(true);
    }

  };

  const handleEditCancel = () => {
    setEditRows(new Set());
    setindexarray([]);
    setEditValues({});
    setTempEditValues({});
    setEditPriceClicked(false);
  };

// --- Generate SVG barcode ---
const generateBarcodeSVG = (value) => {
  const svg = document.createElement("svg");

  JsBarcode(svg, value, {
    format: "CODE128",
    lineColor: "#000",
    height: 60,           // barcode bar height in px
    displayValue: true,   // show numbers
    fontSize: 16,         // number font size
    margin: 0,            // remove extra white border
  });

  return svg.outerHTML;
};

// --- Print Labels ---
const handlePrintLabels = (isPrice) => {
  const labels = selectedProducts
    .map((item) => {
      const barcodeSVG = generateBarcodeSVG(item.barcode);

      return `
        <div class="label">
          <div class="product-name">${item.name}</div>
          ${barcodeSVG}
          ${isPrice ? `<div class="price">EGP ${item.price}</div>` : ""}
        </div>
      `;
    })
    .join("");

  const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8" />
      <title>Print Labels</title>

      <style>
        @page {
          size: 35mm 30mm;
          margin: 0;
        }

        body {
          margin: 0;
          padding: 0;
          font-family: Arial, sans-serif;
          display: flex;
          flex-direction: column;
          align-items: center; /* center all labels horizontally */
        }

        .label {
          page-break-after: always;
          width: 35mm;
          height: 24mm;
          overflow: hidden;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
         justify-content: flex-start;
          text-align: center;
          padding: 1mm 0;
          margin: 0 auto;
        }

        /* --- CRITICAL: CONTROL BARCODE SIZE + CENTER --- */
        .label svg {
          width: 32mm;        /* full width minus padding */
          height: 10mm;       /* ~40px barcode height */
          display: block;
          margin: 0 auto;
        }

        .product-name {
          font-size: 2.7mm;
          max-height: 9mm;
          overflow: hidden;
            margin-top: auto;
            margin-bottom:3px;
        }

        .price {
          font-size: 3mm;
          margin-top: 3px;
        }
      </style>
    </head>

    <body>
      ${labels}
    </body>
    </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(htmlContent);
  printWindow.document.close();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 300);
};




  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    state: { pageSize },
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination,
    // useRowSelect,
    // (hooks) => {
    //   hooks.visibleColumns.push((cols) => [
    //     {
    //       id: "selection",
    //       Header: ({ getToggleAllRowsSelectedProps }) => (
    //         <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
    //       ),
    //       Cell: ({ row }) => (
    //         <input type="checkbox" {...row.getToggleRowSelectedProps()} />
    //       ),
    //       width: 20,
    //     },
    //     ...cols,
    //   ]);
    // }
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <Modal
        visible={isImageModalVisible}
        onCancel={() => setIsImageModalVisible(false)}
        footer={null}
      >
        <img src={currentImageUrl} alt="Product" style={{ width: "100%" }} />
      </Modal>
{showPriceModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-2xl p-8 w-[500px] shadow-2xl text-center">

      {/* Label size sample image */}
      <div className="flex justify-center mb-5">
        <img
          src={labelSample}
          alt="Label size example"
          className="w-72 rounded-lg border"
        />
      </div>

      <p className="text-base text-gray-700 mb-4">
        {t("Your labels are sized 35mm × 24mm as shown above.")}
      </p>

      <h2 className="text-xl font-semibold mb-6">
        {t("Do you want to print product price also?")}
      </h2>

      <div className="flex justify-between mt-4">
        <button
          className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
          onClick={() => {
            setShowPriceModal(false);
            handlePrintLabels(false); // Without price
          }}
        >
          {t("No")}
        </button>

        <button
          className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
          onClick={() => {
            setShowPriceModal(false);
            handlePrintLabels(true); // With price
          }}
        >
          {t("Yes")}
        </button>
      </div>

    </div>
  </div>
)}



      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >

        {selectedProducts.length > 0 && (
          <div className="flex justify-end mb-4">
            <button
              onClick={()=>setShowPriceModal(true)}
              className="w-32 h-8 bg-[#7EC242] text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
            >
              Print Labels
            </button>
          </div>
        )}

        {/* Save All button */}
        {editPriceClicked && (
          <div className="flex justify-end mb-5">
            {editRows.size === 1 ? (
              <button
                onClick={handleSaveAll}
                className="w-28 h-8 mt-1 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
              >
                <span>{t("save")}</span>
              </button>
            ) : (
              <button
                onClick={handleSaveAll}
                className="w-28 h-8 mt-1 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
              >
                <span>{t("save_all")}</span>
              </button>
            )}
            <button
              onClick={handleEditCancel}
              className="w-28 h-8 mt-1 bg-white border border-primaryBlue text-primaryBlue text-sm font-semibold rounded-lg flex items-center justify-center me-5"
            >
              <span>{t("Cancel")}</span>
            </button>
          </div>
        )}

        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal mx-auto max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold text-center overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex items-start text-sm justify-center ">
                                {column.render("Header")}
                                <span className="">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <img
                                        src={Vectorsorting}
                                        style={{ minHeight: 10, minWidth: 10 }}
                                        alt="vector"
                                      />
                                    ) : (
                                      <img
                                        className="rotate-180"
                                        src={Vectorsorting}
                                        alt="vector"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal mx-auto max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-start overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white transition duration-300 border-b border-gray-300 fixed-row-height"
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                } ${cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                                }`}
                              style={{
                                width: cell.column.width,
                                textAlign:
                                  cell.column.headerClassName?.includes(
                                    "text-center"
                                  )
                                    ? "center"
                                    : cell.column.headerClassName?.includes(
                                      "text-start"
                                    )
                                      ? "left"
                                      : "center",
                              }}
                            >
                              <div
                                className={`flex ${cell.column.headerClassName?.includes(
                                  "text-center"
                                )
                                  ? "justify-center"
                                  : cell.column.headerClassName?.includes(
                                    "text-start"
                                  )
                                    ? "justify-start"
                                    : "justify-center"
                                  }`}
                              >
                                {cell.render("Cell")}
                              </div>
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {showpopup && (
                    <ProductModal
                      onClose={() => setshowpopup(false)}
                      data={showpopupdata}
                    />
                  )}
                  {/* Empty state row */}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {/* Pagination */}
              <div>
                <CustomPagination
                  data={data?.length}
                  pageIndex={pageIndex}
                  pageCount={page?.length}
                  canPreviousPage={pageIndex != 1 ? true : false}
                  canNextPage={data?.length == pageSize ? true : false}
                  gotoPage={(page) => {
                    nextPage(page);
                  }}
                  previousPage={() => {
                    setpageIndex(pageIndex - 1);
                  }}
                  nextPage={() => {
                    setpageIndex(pageIndex + 1);
                  }}
                  pageSize={pageSize}
                  setPageSize={(pageSize) => {
                    setPageSize(pageSize);
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InventoryTableComponent;
